import { layout } from './layout.theme';
import { colors } from './colors.theme';
import { spacing } from './spacing.theme';
import { text } from './text.style';
import { breakpoints } from './breakpoints.theme';
import { ThemeProps } from '../../types/theme';


export const theme: ThemeProps = {
	colors,
	spacing,
	text,
	breakpoints,
	layout
};
